import axios from 'axios'
import { publicIp } from 'public-ip'
import generateID from '@helpers/generateID'

const TRACKING_ID = process.env.NEXT_PUBLIC_FB_PIXEL

declare const fbq: any

const trackPageView = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    fbq('track', 'PageView')
  }
}

const trackEvent = async (eventName: string) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    let ip = null
    try {
      ip = await publicIp()
    } catch {
    } finally {
      const eventID = generateID(16)

      fbq('track', eventName, null, { eventID })

      await axios.post('/api/facebook/conversions', {
        eventName: eventName,
        eventID,
        url: window.location.href,
        ip
      })
    }
  }
}

const trackPurchase = async (payment: { currency: string; value: number }) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    const ip = await publicIp()

    const eventID = Date.now()

    fbq('track', 'Purchase', payment, { eventID })

    const conversions = await axios.post('/api/facebook/conversions', {
      eventName: 'Purchase',
      eventID,
      url: window.location.href,
      ip: ip,
      ...payment
    })
  }
}

const fbpixel = { TRACKING_ID, trackPageView, trackEvent, trackPurchase }

export default fbpixel
